import React from 'react';
import PropTypes from 'prop-types';

import BrandViewProductsItem from './BrandViewProductsItem';
import ShowMoreButton from '../ShowMoreButton';
import FilterMenu from '../FilterMenu';

const BrandViewProductsContent = ({
  products,
  levelOneCategoriesFacet,
  selectedProductType,
  onProductTypeChange,
  productsCount,
  selectedProduct,
  showMoreProductsHandler,
  hasNextPage,
  onProductOpenClick,
  isLoading,
  isFiltering,
}) => (
  <div className="row">
    <div className="large-3 medium-12 small-12 columns">
      <FilterMenu
        filters={levelOneCategoriesFacet}
        selectedFilter={selectedProductType}
        filterChangeHandler={onProductTypeChange}
        isLoading={isFiltering}
      />
    </div>
    <div className="columns p-r">
      <div className="row small-up-2 medium-up-3">
        {products.map((product, index) => (
          <BrandViewProductsItem
            product={product}
            _onProductOpenClick={onProductOpenClick}
            selectedProduct={selectedProduct}
            index={index}
            key={product.id}
          />
        ))}
      </div>
      <ShowMoreButton
        showMoreHandler={showMoreProductsHandler}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        remainingItems={productsCount - products.length}
        text="View More Products"
      />
      {isFiltering && <div className="p-a relative-center m-auto bg-white cursor-not-allowed" style={{ opacity: 0.85 }} />}
    </div>
  </div>
);

BrandViewProductsContent.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  levelOneCategoriesFacet: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedProductType: PropTypes.string,
  onProductTypeChange: PropTypes.func.isRequired,
  productsCount: PropTypes.number,
  selectedProduct: PropTypes.shape({}).isRequired,
  showMoreProductsHandler: PropTypes.func.isRequired,
  onProductOpenClick: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isFiltering: PropTypes.bool.isRequired,
};

BrandViewProductsContent.defaultProps = {
  productsCount: 0,
  selectedProductType: 'All',
};

export default BrandViewProductsContent;
